import { computed, ref } from 'vue';
import { ProductWishlist } from '@/shared/product/wishlist/useWishlistApi';

const activeSku = ref<string | undefined>();
const activeName = ref<string | undefined>();
const lists = ref<ProductWishlist[]>([]);
export const ensureOverlayAnimationBeforeClosingTiming = 1000;
export default function useWishlist() {
    const active = computed(() => activeSku.value !== undefined);
    const setActiveSku = (sku: string) => activeSku.value = sku;
    const setActiveName = (name?: string) => activeName.value = name;
    const clearActiveSku = () => activeSku.value = undefined;
    const clearActiveName = () => activeName.value = undefined;
    const setActive = (sku: string, name?: string) => {
        setActiveSku(sku);
        name && setActiveName(name);
    };
    const clearActive = () => {
        clearActiveSku();
        clearActiveName();
    };
    const setLists = (result: ProductWishlist[]) => {
        lists.value = result;
    };
    const clearLists = () => {
        lists.value.length = 0;
    };
    const getIsInLists = (sku: string) => {
        const skus: string[] = [];
        lists.value.forEach(list => skus.push(...list.skus.map(listSku => listSku.sku)));
        return skus.includes(sku);
    };

    return {
        active,
        activeSku,
        activeName,
        lists,
        setActive,
        clearActive,
        setLists,
        clearLists,
        getIsInLists,
    };
}
